import PanToolIcon from '@mui/icons-material/PanTool';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';

export function ManualMatchIndicator() {
  const { $t } = useIntl();

  return (
    <Chip
      size="small"
      variant="outlined"
      label={$t({
        id: 'audit.props.manualMatch',
        defaultMessage: 'Match manual',
      })}
      icon={<PanToolIcon />}
    />
  );
}
